import React from 'react';
import { useCheckout } from './CheckoutContext';
export function StickyCTA() {
  const {
    openUpsell,
    warmConnection
  } = useCheckout();
  return <div className="fixed bottom-0 left-0 right-0 z-50 bg-brand-black border-t border-brand-gold" data-id="element-186">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-4" data-id="element-187">
        <div className="flex flex-col" data-id="element-188">
          <span className="text-xs text-brand-gray line-through" data-id="element-189">
            ANTES $50.000
          </span>
          <span className="text-lg sm:text-xl font-bold text-brand-gold" data-id="element-190">
            HOY $19.990
          </span>
        </div>
        <button onClick={openUpsell} onMouseEnter={warmConnection} onTouchStart={warmConnection} className="bg-brand-gold text-brand-black px-6 py-2.5 sm:px-8 sm:py-3 rounded font-semibold text-sm sm:text-base hover:opacity-90 transition-opacity whitespace-nowrap" data-id="element-191">
          QUIERO ACCESO
        </button>
      </div>
    </div>;
}